import { render, staticRenderFns } from "./PcStaticFileValue.vue?vue&type=template&id=835f66ca"
import script from "./PcStaticFileValue.vue?vue&type=script&lang=js"
export * from "./PcStaticFileValue.vue?vue&type=script&lang=js"
import style0 from "./PcStaticFileValue.vue?vue&type=style&index=0&id=835f66ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports